/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import type { MemberManagerRegisterResponse } from "./MemberManagerRegisterResponse";

export type MemberManagerRegisterResponseApiRespoonse = {
  data?: MemberManagerRegisterResponse;
  status?: MemberManagerRegisterResponseApiRespoonse.status;
  message?: string;
  errors?: Record<string, Array<string>>;
};

export namespace MemberManagerRegisterResponseApiRespoonse {
  export enum status {
    SUCCESS = "success",
    ERROR = "error",
  }
}
